"use client"

import Header from "@/components/navigation";
import Footer from '@/components/footer';
import ScrollToTop from '@/components/scrollToTop';
import { usePathname } from 'next/navigation';
import { AnimatePresence } from 'framer-motion';
import PageTransition from '@/components/layout/PageTransition';

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isStudioRoute = pathname?.startsWith('/studio');

  // Don't render layout elements for studio routes
  if (isStudioRoute) {
    return children;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow w-full">
        <AnimatePresence mode="wait">
          <PageTransition key={pathname}>
            {children}
          </PageTransition>
        </AnimatePresence>
        <ScrollToTop />
      </main>
      <Footer />
    </div>
  );
} 